module.exports = __webpack_public_path__ + "img/cancel_red.b8c70537.svg";